import React from "react"
import { graphql } from "gatsby"
import { Post } from "@molecules"
import { Seo } from "@atoms"
import { Layout } from "@organisms"
import { mapEdgesToNodes } from "@utilities/sanity"
import useTrackingScrollPercentage from "@src/hooks/useTrackingScrollPercentage"

export const query = graphql`
  query blogPageQuery {
    allSanityPost(
      sort: { fields: [_createdAt], order: DESC }
      filter: { slug: { current: { ne: null } } }
      limit: 100
    ) {
      edges {
        node {
          id
          title
          _rawExcerpt
          slug {
            current
          }
          mainImage {
            alt
            asset {
              fluid(maxWidth: 2000) {
                ...GatsbySanityImageFluid
              }
            }
          }
        }
      }
    }
  }
`

const BlogIndex = ({ data }) => {
  useTrackingScrollPercentage(
    0.75,
    "Scoll75PercentBlogPage",
    "75 percent vertical scroll - Blog page"
  )
  const posts = (data || {}).allSanityPost
    ? mapEdgesToNodes(data.allSanityPost)
    : []

  return (
    <Layout>
      <div className="bg-gray-50 pt-10 pb-20 px-4 sm:px-6 lg:pt-16 lg:pb-28 lg:px-8">
        <Seo title="Blog" />
        <div className="max-w-7xl mx-auto">
          <div className="text-center">
            <h1 className="text-4xl leading-9 tracking-tight sm:text-5xl sm:leading-10 pt-10 border-t-2 border-info-50 inline-block px-4 sm:px-6 md:px-24">
              Blog
            </h1>
          </div>
          <div className="mt-12 grid col-gap-5 row-gap-10 max-w-lg mx-auto lg:grid-cols-3 lg:max-w-none">
            {posts.map(post => (
              <Post key={post.id} {...post} />
            ))}
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default BlogIndex
